import { Paper, Typography } from "@mui/material"
import TopKeywordsTable from "./TopKeywordsTable"
import { Box } from "@mui/system"
import { useSelector } from "react-redux";

const tableHeadings = {
  keyword_name: "KeyWord",
  matchtype: "Match Type",
  traffic_source: "Traffic Source",
  adgroup_name: "Ad Group",
  campaign_name: "Campaign",
  lp_exp_score_weight: "LP Experience",
  cost: "Cost",
  quality_score_weight: "QS",
};



const TopKeywordsCard = () => {
    const {performanceByKeywords} = useSelector((state:any) => state.landingPageExperience);
    return (
    <>
     <Paper>
      <Box sx={{ padding: "8px 16px",}}>
        <Typography fontSize={24}>Top Keywords</Typography>
        <Typography sx={{ color: "#00000099", }}>
          5 keywords with highest cost and the best landing page experience score.
        </Typography>
      </Box>
       
         {performanceByKeywords?.length > 0 ? (
      <>
           <TopKeywordsTable tableHeadings={tableHeadings} records={performanceByKeywords} />
      </>
    ): (
      <Typography fontSize={20} sx={{textAlign:"center",padding: "8px 16px"}}>No data to display</Typography>
    )}
      </Paper>
    </>
  )
}

export default TopKeywordsCard